import { type CSSProperties } from 'react'
import { css, type SerializedStyles } from '@emotion/react'
import { type Theme } from '@mui/material/styles'
import { rem } from 'polished'

import { typographyOverrides } from '@Material/typography'
import { RADIUS_1 } from '@Styles/constants/radius'
import { getFocusVisibleStyle } from '@Styles/focus'

export const actionButton = (theme: Theme): SerializedStyles =>
  css({
    ...(typographyOverrides(theme)?.button as CSSProperties),
    '&:focus-visible': {
      outline: 'none',
    },
    '&:focus-visible::before': getFocusVisibleStyle(theme.palette.primary.main, RADIUS_1, '0'),
    '&:hover': {
      color: theme.palette.primary.dark,
    },
    backgroundColor: 'transparent',
    border: 'none',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    fontSize: rem(13),
    fontWeight: 500,
    lineHeight: rem(18),
    margin: 0,
    outline: 'inherit',
    padding: theme.spacing(2),
    position: 'relative',
  })
